<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Dropdown with Sample File</title>
  <style>
    .dropdown-container {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .sample-file {
      font-size: 0.9em;
      color: #555;
      text-decoration: underline;
      cursor: pointer;
    }
  </style>
</head>
<body>
  <div class="dropdown-container">
    <label for="forms-dropdown">Forms:</label>
    <select id="forms-dropdown" name="forms">
      <option value="form1">Form 1</option>
      <option value="form2">Form 2</option>
      <option value="form3">Form 3</option>
    </select>
    <span class="sample-file">Sample File</span>
  </div>
</body>
</html>